import { request } from '../request';

export default {
  list: (data, config = {}) => request('/api/products/list', 'post', data, config),
  filter: (data) => request('/api/products/params', 'get', data),
  search: (data) => request('/api/products/search', 'get', data),
};
